import React from "react";
import { Card, CardBody, CardHeader, Divider, Heading, Stack } from "@chakra-ui/react";
import ActivityRow from "./ActivityRow";
import EmptyState from "./EmptyState";
import LoadingState from "./LoadingState";

const ActivityFeed = ({ items, isLoading, formatDateTime, statusColor }) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <Heading size="sm">Recent Activity</Heading>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <LoadingState />
        ) : items.length === 0 ? (
          <EmptyState title="No activity yet" description="Activity will show up as payments and subscriptions update." />
        ) : (
          <Stack spacing={4} divider={<Divider />}>
            {items.map((item) => (
              <ActivityRow
                key={item.id}
                item={item}
                formatDateTime={formatDateTime}
                statusColor={statusColor}
              />
            ))}
          </Stack>
        )}
      </CardBody>
    </Card>
  );
};

export default ActivityFeed;
